// @flow

export default class Amenities {
  games: boolean;
  green_areas: boolean;
  events_room: boolean;
  tennis_court: boolean;
  visits_space: boolean;
  roaster: boolean;
  cistern: boolean;
  service_room: boolean;
  elevator: boolean;
  bowling: boolean;
  sauna: boolean;
  squash_court: boolean;
  jacuzzi: boolean;
  pool: boolean;
  security: boolean;
  lobby: boolean;
  gym: boolean;
  cinema: boolean;
  
  constructor(data: any = {}) {
    this.games = data.games;
    this.green_areas = data.green_areas;
    this.events_room = data.events_room;
    this.tennis_court = data.tennis_court;
    this.visits_space = data.visits_space;
    this.roaster = data.roaster;
    this.cistern = data.cistern;
    this.service_room = data.service_room;
    this.elevator = data.elevator;
    this.bowling = data.bowling;
    this.sauna = data.sauna;
    this.squash_court = data.squash_court;
    this.jacuzzi = data.jacuzzi;
    this.pool = data.pool;
    this.security = data.security;
    this.lobby = data.lobby;
    this.gym = data.gym;
    this.cinema = data.cinema;
  }
}

